import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconHandshake({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.375} d="m18.75 14.004-4.787.957M14.438 9.531l-2.26.955a1.42 1.42 0 0 1-1.122-.016 1.48 1.48 0 0 1-.781-.83 1.525 1.525 0 0 1 .706-1.9l2.259-1.127a1.96 1.96 0 0 1 1.594-.094l4.639 1.828" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.375} d="M5.2 15h1.6l3.049 2.326a.83.83 0 0 0 1.15.09l4.26-3.518a.84.84 0 0 0 .129-1.164l-2.347-2.609M10.736 7.9l-.247-.2a1.79 1.79 0 0 0-1.725-.22L5.194 9" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.375} d="M1.39 15.75h2.66a1.14 1.14 0 0 0 1.2-1.072V9.321a1.14 1.14 0 0 0-1.2-1.07H1.39M22.61 15.75h-2.66a1.14 1.14 0 0 1-1.2-1.072V9.321a1.14 1.14 0 0 1 1.2-1.07h2.66" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.375} d="M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25" /></svg></>;
}
IconHandshake.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconHandshake;